import { render, staticRenderFns } from "./NameNsDescription.vue?vue&type=template&id=ac90c7d2&scoped=true&"
import script from "./NameNsDescription.vue?vue&type=script&lang=js&"
export * from "./NameNsDescription.vue?vue&type=script&lang=js&"
import style0 from "./NameNsDescription.vue?vue&type=style&index=0&id=ac90c7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac90c7d2",
  null
  
)

export default component.exports